// Environment variable helpers for Vite migration
// Vite uses import.meta.env instead of process.env

const hasImportMeta = typeof import.meta !== 'undefined';

export const getPublicUrl = () => {
  // In Vite, use import.meta.env.BASE_URL
  if (hasImportMeta && import.meta.env) {
    return import.meta.env.BASE_URL || '/r';
  }
  // Fallback for tests or legacy
  return (typeof process !== 'undefined' && process.env?.PUBLIC_URL) || '/r';
};

export const getEnv = (key) => {
  // Try Vite first
  if (hasImportMeta && import.meta.env) {
    return import.meta.env[`VITE_${key}`] || import.meta.env[key];
  }
  // Fallback to process.env for legacy support
  if (typeof process !== 'undefined' && process.env) {
    return process.env[`REACT_APP_${key}`] || process.env[key];
  }
  return undefined;
};

export const isDev = () => {
  if (hasImportMeta && import.meta.env) {
    return import.meta.env.DEV;
  }
  if (typeof process !== 'undefined' && process.env) {
    return !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
  }
  return true; // Default to dev mode
};

export const isProd = () => {
  if (hasImportMeta && import.meta.env) {
    return import.meta.env.PROD;
  }
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NODE_ENV === 'production';
  }
  return false;
};

export const getMode = () => {
  if (hasImportMeta && import.meta.env) {
    return import.meta.env.MODE;
  }
  if (typeof process !== 'undefined' && process.env) {
    return process.env.NODE_ENV || 'development';
  }
  return 'development';
};
